export const boxShadows = {
  standard: '0px 4px 11px rgba(0, 0, 0, 0.3)',
} as const;
